import classNames from 'classnames';
import { ChangeEvent, PureComponent, ReactNode } from 'react';
import './index.scss';

interface Props {
  checked: boolean | number;
  className: string;
  disabled: boolean;
  form: boolean;
  id: string;
  label: ReactNode;
  onChange: (changeEvent: ChangeEvent) => void;
}

export class Checkbox extends PureComponent<Props> {
  public static defaultProps = {
    checked: false,
    className: '',
    disabled: false,
    form: false,
    label: '',
  };

  public render() {
    const { id, label, checked, className, form, onChange, disabled } =
      this.props;

    return (
      <span
        className={classNames(className, 'Checkbox', {
          'Checkbox--form': form,
        })}
      >
        <input
          id={id}
          type="checkbox"
          checked={Boolean(checked)}
          className="checkbox"
          onChange={onChange}
          disabled={disabled}
        />
        <label htmlFor={id}>{label}</label>
      </span>
    );
  }
}
